var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletEntranceSlope = function SvgIcToiletEntranceSlope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.25,
    y: 4.068,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.25,
    y: 4.068,
    fill: "#67AEFF",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M30.25 28.068V15.542c0-1.542-1.67-2.504-3.004-1.73L5.673 26.338c-1.767 1.026-1.04 3.73 1.004 3.73H28.25a2 2 0 0 0 2-2Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.25,
    y: 4.068,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.25,
    y: 4.068,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgIcToiletEntranceSlope;